import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManufacturingComponent } from './manufacturing/manufacturing.component';

import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import { OuropinionCasestudyComponent } from './ouropinion-casestudy/ouropinion-casestudy.component';
import { CurorcComponent } from './curorc/curorc.component';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { FinanceComponent } from './finance/finance.component';

import { register } from 'swiper/element/bundle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { EntertainmentComponent } from './entertainment/entertainment.component';
import { RetailComponent } from './retail/retail.component';
import { IndustriesRoutingModule } from './industries-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { FutekCasestudyComponent } from './futek_casestudy/futek_casestudy.component';

register();
@NgModule({
  declarations: [
    ManufacturingComponent,
    OuropinionCasestudyComponent,
    CurorcComponent,
    FinanceComponent,
    EntertainmentComponent,
    RetailComponent,
    // FutekCasestudyComponent,
  
  ],schemas:[CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,MatTabsModule,MatIconModule,CdkAccordionModule,FontAwesomeModule,
    BrowserModule,BrowserAnimationsModule,CarouselModule, IndustriesRoutingModule,SharedModule
  ]
})
export class IndustriesModule { }
